import React, { useState } from 'react'
import { Container, Form, Row, Col, Button } from 'react-bootstrap'
import styles from '../../../styles/Home.module.css'
import { useRouter } from 'next/router'
const SchaduleDemo = () => {
  const [email, setEmail] = useState('')
  const router = useRouter()
  return (
    <Container className={styles.LandingSectionCard} style={{ margin: '4em auto' }}>
      <div className={styles.T3bgOverlayGradient}>
        <div>
          <h1 className={styles.featuresTitle} style={{ fontSize: '2em' }}>
            Schedule A Demo For WebHR
          </h1>
          <p className={styles.featuresSubtitle} style={{ fontSize: '1.24em' }}>
            Enter your email to schedule a personalized demo to see WebHR in action
          </p>
          <div style={{ display: 'flex', maxWidth: '500px', margin: '0 auto' }}>
            <Form.Label htmlFor="email" style={{ display: 'none', margin: 0 }}></Form.Label>
            <Form.Control
              id="email"
              name="email"
              type="text"
              placeholder="Your Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.emailInput}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  router.push({
                    pathname: '/signup/step1',
                    query: { ea: email },
                  })
                }
              }}
            />

            <Button
              className={styles.secondaryBtnBanner}
              style={{ borderRadius: '0 6px 6px 0 ' }}
              onClick={() =>
                router.push({
                  pathname: '/demo',
                  query: { ea: email },
                })
              }
            >
              Schedule a Demo
            </Button>
          </div>{' '}
        </div>
      </div>
    </Container>
  )
}

export default SchaduleDemo
